import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '../../shared/services/config.service';
import { AuthStateService } from './auth-state.service';
import { catchError, switchMap, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(ConfigService);
  const authState = inject(AuthStateService);

  // Skip absolute URLs (third-party calls)
  if (req.url.startsWith('http')) return next(req);

  const modified = req.clone({
    url: `${config.apiBaseUrl}${req.url}`,
    setHeaders: { 'X-Platform': 'WEB' },  // backend expects uppercase
    withCredentials: true,                 // send HttpOnly cookies automatically
  });

  return next(modified).pipe(
    catchError((err: HttpErrorResponse) => {
      // Only attempt refresh on 401, and not on auth endpoints themselves.
      // Logout is the exception: it's guarded by the access token, so an
      // expired access cookie must be refreshed for the server-side revoke to run.
      const isAuthEndpoint = req.url.includes('/auth/') && !req.url.includes('/auth/logout');
      if (err.status === 401 && !isAuthEndpoint) {
        // Mid-session expiry → silent refresh → retry
        return authState.refresh().pipe(
          switchMap(() => next(modified)),
          catchError((refreshErr) => {
            authState.forceLogout();
            return throwError(() => refreshErr);
          }),
        );
      }
      return throwError(() => err);
    }),
  );
};
